/**
 * Created by Astha on 5/10/2018.
 */
//@flow
import {Logger}  from './../../logger/Logger';
import  {
  SetCollectionSettingsQuery,
  SetCollectionSettingsMessage,
  SetCollectionSettingsResponse
} from '../../autogenerated/ZoomBridge';
import HashMap from "../../protocol/HashMap";


export default class SetCollectionSettings {

  logger: Logger;
  _propName2Value: HashMap;

  constructor(collectionId: number, userId: string, propName2Value: ?HashMap = null) {
    this.logger = new Logger('SetCollectionSettings');
    this._collectionId = collectionId;
    this._userId = userId;
    this._propName2Value = propName2Value;
  }

  setPropName2PropValue(propName: string, propValue: string) {
    if (!this._propName2Value) {
      this._propName2Value = new HashMap();
    }

    this._propName2Value.put(propName, propValue);
  }

  setSettingsOfCollection(): Promise<SetCollectionSettingsResponse> {
    const query: SetCollectionSettingsQuery = new SetCollectionSettingsQuery();
    const message: SetCollectionSettingsMessage = new SetCollectionSettingsMessage();
    message.setCollectionId(this._collectionId);
    message.setUserId(this._userId);
    message.setPropName2ValueMap(this._propName2Value);
    query.message = message;
    return query.run();
  }
}

